export default __webpack_public_path__ + "static/media/SphereCoreForces.611e8eab.webp";